export default "__VITE_ASSET__Dy$dStES__"